/**
 *  弹出滑动验证弹窗
 */

import './pop.css'
import cookie from '../modules/cookie'

var cd: string | number | NodeJS.Timeout | undefined;

function OpenSliderValid(){
  function Init(){
    let div = document.createElement('div')
    div.className = 'popwscps_d'

    let shadow = document.createElement('div')
    shadow.className = 'popwscps_d_shadow'
    div.appendChild(shadow)

    document.body.appendChild(div)

    let iframe = document.createElement('iframe')
    iframe.className = 'popwscps_d_iframe'
    iframe.src = 'https://i.eastmoney.com/websitecaptcha/slidervalid' //http://auth.eastmoney.com:43472/slidervalid
 
    div.appendChild(iframe)
    cookie.del('wsc_checkuser_ok', '.eastmoney.com')

    window.addEventListener('message', function(event) {
      if (event.origin !== "https://i.eastmoney.com") { //http://auth.eastmoney.com:43472
        return; // 不是来自预期的域，忽略消息
      }
      console.log(event.data); // 处理接收到的数据
      if(event.data === 'silidervalid_ok'){
        cookie.set('wsc_checkuser_ok', '1', undefined, '.eastmoney.com')
        try {
          clearInterval(cd)
        } catch (error) {
          
        }
        document.body.removeChild(div)
      }

    });
    cd = setInterval(() => {
      var wsc_checkuser_cookie = cookie.get('wsc_checkuser_ok')
      if(wsc_checkuser_cookie){
        document.body.removeChild(div)
      }
    }, 200);    
  }
  


  Init()
}




var jsonp = require('../modules/jsonp')

function checkUser(){
    jsonp('https://i.eastmoney.com/websitecaptcha/api/checkuser', {
      name: 'wsc_checkuser'
    }, function(error: any, data:any) {
      if(data && data.block == true){
        OpenSliderValid()
      }
    })
}

(window as any)['websitecaptcha_checkuser'] = checkUser


checkUser()